function hasSpanStreamingEnabled(client) {
  return client.getOptions().traceLifecycle === "stream";
}

export { hasSpanStreamingEnabled };
//# sourceMappingURL=hasSpanStreamingEnabled.js.map
